// Generator-discovered file route for the accounts registry. Component lives in
// `src/ad/routes/accounts.tsx` (Module K / K3).
import { createFileRoute } from '@tanstack/react-router';
import { AccountsRouteComponent } from '@/ad/routes/accounts';

export const Route = createFileRoute('/_authenticated/ad/accounts')({
  component: AccountsRouteComponent,
});
